import type { FC } from "react";
import { twMerge } from "tailwind-merge";
import { ThinkingDots } from "./thinkingDots.js";

export interface MessageThinkingIndicatorProps {
  label?: string;
  className?: string;
}

/**
 * Shown while the assistant is working and nothing else on screen says so. Laid
 * out like a tool call's status line, so the dots sit in the status icon's
 * column.
 */
export const MessageThinkingIndicator: FC<MessageThinkingIndicatorProps> = ({
  label = "Thinking...",
  className,
}) => (
  <div
    role="status"
    className={twMerge(
      "flex h-6 items-center gap-1.5 pl-[var(--chat-tool-inset,--spacing(3.5))] text-xs font-medium text-muted-foreground",
      className,
    )}
  >
    <ThinkingDots />
    <span>{label}</span>
  </div>
);
